import * as React from "react";
import { FC } from "react";
import { ProductSegment } from "~/apps/pos/models";
import Table from "~/common/components/Table";
import DropDownButtons from "~/common/controls/DropDownButtons";

type Props = {
  data: ProductSegment[];
  page: number;
  pageSize: number;
  loading: boolean;
  onPageChange: (page: number) => void;
  onEdit: (row: ProductSegment) => void;
  onDelete: (row: ProductSegment) => void;
};

const ProductSegmentsTable: FC<Props> = ({ data, loading, pageSize, page, onEdit, onDelete, onPageChange }) => {
  const columns = [
    {
      Header: "Name",
      id: "name",
      accessor: (row) => row.name,
    },
    {
      Cell: (row) => {
        const options = [
          {
            onClick: () => onEdit(row.original),
            title: "Edit",
          },
          { onClick: () => onDelete(row.original), title: "Delete" },
        ];

        return <DropDownButtons options={options} />;
      },

      width: 100,
    },
  ];

  return (
    <Table
      columns={columns}
      manual={true}
      data={data}
      loading={loading}
      pageSize={pageSize}
      page={page}
      onEdit={onEdit}
      onDelete={onDelete}
      onPageChange={onPageChange}
    />
  );
};
export default ProductSegmentsTable;
